import React, { useState } from 'react'
import { formatDuration } from '@handlers/sessions/util'
import moment from 'moment'
import { Flex, Text, Link, Button } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { useMutation } from 'react-query'

import { endpoints } from '@api'

const Details = ({ client, session, refresh, progressNote }: any) => {
  const [startedAt, setStartedAt] = useState(moment(session.startedAt))
  const [completedAt, setCompletedAt] = useState(moment(session.completedAt))
  const [isEditingStartTime, setIsEditingStartTime] = useState(false)
  const [isEditingEndTime, setIsEditingEndTime] = useState(false)

  const { mutate: updateTimestamps }: { mutate: Function } = useMutation(
    // @ts-ignore
    endpoints.patchSessionTimestampOverrides.request,
    {
      onSuccess: () => {
        refresh()
        setIsEditingStartTime(false)
        setIsEditingEndTime(false)
      }
    }
  )

  return (
    <Flex
      flexDirection="column"
      border="1px solid"
      borderColor="pale_gray"
      borderRadius="8px"
      p="16px"
      gap="16px"
    >
      <Flex>
        <Text fontWeight="bold">Overview</Text>
      </Flex>
      <Flex flexDirection="column" gap="8px">
        <Text>
          <b>Client:</b>&nbsp;
          <Link color="primary" as={RouterLink} to={`/patient/${client.id}`}>
            {client.first_name} {client.last_name}
          </Link>
        </Text>
        <Text>
          <b>Date:</b>&nbsp;
          {moment.utc(session.date).format('ddd MMM D, YYYY')}
        </Text>
        {!session.fileUploadId && (
          <>
            <Flex>
              <Text>
                <b>Start Time:</b>&nbsp;
                {!isEditingStartTime &&
                  moment(session.startedAt).format('h:mma')}
              </Text>
              {!isEditingStartTime && (
                <Link
                  ml="xsmall"
                  color="primary"
                  onClick={() => setIsEditingStartTime(!isEditingStartTime)}
                >
                  Edit
                </Link>
              )}
            </Flex>
            {isEditingStartTime && (
              <>
                <input
                  type="time"
                  style={{
                    border: '1px solid #E4E5E6',
                    borderRadius: '5px',
                    padding: '5px 5px'
                  }}
                  defaultValue={startedAt.format('HH:mm')}
                  onChange={e =>
                    setStartedAt(
                      startedAt.set({
                        hour: Number(e.target.value.split(':')[0]),
                        minute: Number(e.target.value.split(':')[1])
                      })
                    )
                  }
                />
                <Flex>
                  <Button
                    size="sm"
                    variant="outline"
                    ml="0"
                    onClick={() => {
                      setIsEditingStartTime(false)
                      setStartedAt(moment(session.startedAt))
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="sm"
                    onClick={() =>
                      updateTimestamps({
                        sessionId: session.id,
                        data: {
                          startedAtOverride: startedAt,
                          completedAtOverride: completedAt
                        }
                      })
                    }
                  >
                    Save
                  </Button>
                </Flex>
              </>
            )}
            <Flex>
              <Text>
                <b>End Time:</b>&nbsp;
                {!isEditingEndTime &&
                  moment(session.completedAt).format('h:mma')}
              </Text>
              {!isEditingEndTime && (
                <Link
                  ml="xsmall"
                  color="primary"
                  onClick={() => setIsEditingEndTime(!isEditingEndTime)}
                >
                  Edit
                </Link>
              )}
            </Flex>
            {isEditingEndTime && (
              <>
                <input
                  type="time"
                  style={{
                    border: '1px solid #E4E5E6',
                    borderRadius: '5px',
                    padding: '5px 5px'
                  }}
                  defaultValue={completedAt.format('HH:mm')}
                  onChange={e =>
                    setCompletedAt(
                      completedAt.set({
                        hour: Number(e.target.value.split(':')[0]),
                        minute: Number(e.target.value.split(':')[1])
                      })
                    )
                  }
                />
                <Flex>
                  <Button
                    size="sm"
                    variant="outline"
                    ml="0"
                    onClick={() => {
                      setIsEditingEndTime(false)
                      setCompletedAt(moment(session.endedAt))
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="sm"
                    onClick={() =>
                      updateTimestamps({
                        sessionId: session.id,
                        data: {
                          startedAtOverride: startedAt,
                          completedAtOverride: completedAt
                        }
                      })
                    }
                  >
                    Save
                  </Button>
                </Flex>
              </>
            )}
            <Text>
              <b>Duration:</b>&nbsp;
              {formatDuration(session.startedAt, session.completedAt)}
            </Text>
          </>
        )}
        <Text>
          <b>Note Type:</b>&nbsp;
          {progressNote?.template?.displayShort || 'Unknown'}
        </Text>
      </Flex>
    </Flex>
  )
}

export default Details
